import { useAuditReportsGetGipMetadataCampaigns } from '@mi-front/api-v2';
import { DateTimeStr } from '@mi-front/core';

/**
 * Campaigns list for the GIP form via api-v2 audit-reports metadata.
 */
export function useGipCampaignsQuery(
  params: {
    from: DateTimeStr;
    to: DateTimeStr;
    stations: string[];
    advertisers: string[];
  },
  enabled: boolean,
) {
  return useAuditReportsGetGipMetadataCampaigns(params, {
    query: {
      enabled,
      select: (campaigns) => campaigns.filter((v) => !!v),
    },
  });
}
